import React from 'react';

interface BulbIconProps {
  size?: number;
  className?: string;
}

/**
 * Shared "Show me around" mark — the account popover's menu item (Sidebar)
 * and the TasksSidebar footer bulb both render this, so the two entry
 * points read as the same affordance rather than two different icons that
 * happen to do the same thing.
 */
export const BulbIcon: React.FC<BulbIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M9 18h6" />
    <path d="M10 22h4" />
    <path d="M12 2a7 7 0 0 0-4 12.6c.6.5 1 1.3 1 2.1V17h6v-.3c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2Z" />
  </svg>
);
